import React from "react";

const ProjectOne = () => {
  return (
    <div className="my-4">
      <h1 className="text-5xl text-black  my-4">Screen Shots</h1>
      <div className="carousel w-full">
        <div id="item1" className="carousel-item w-full">
          <img src="https://i.ibb.co/qnpGhcY/p3-1.png" className="mx-auto w-fit" />
        </div>
        <div id="item2" className="carousel-item w-full">
          <img src="https://i.ibb.co/JvtJKVb/p3-2.png" className="mx-auto w-fit" />
        </div>
        <div id="item3" className="carousel-item w-full">
          <img src="https://i.ibb.co/Fx6rjTc/p3-3.png" className="mx-auto w-fit" />
        </div>
        
      </div>
      <div className="flex justify-center w-full py-2 gap-2">
        <a href="#item1" className="btn btn-xs">
          1
        </a>
        <a href="#item2" className="btn btn-xs">
          2
        </a>
        <a href="#item3" className="btn btn-xs">
          3
        </a>
        
      </div>
      <div>
        <p className="text-black">
          • Logged-in users can add tasks containing title and description. •
          Added tasks are shown in a tabular format on the same page and
          managing the tasks is possible along with the server and the database.
          • Improved interactions as tasks can be marked completed or can be
          deleted. Completed tasks will become strike-through text.
        </p>
      </div>
      <div className="flex flex-wrap justify-center my-10">
        <a
          className="btn btn-outline mr-4"
          href="https://do-be-done-final.web.app/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Live Site{" "}
        </a>
        <a
          className="btn btn-outline mr-4"
          href="https://github.com/sasohan0/do-be-done-client-final"
          target="_blank"
          rel="noopener noreferrer"
        >
          Front-End Code
        </a>
        <a
          className="btn btn-outline"
          href="https://github.com/sasohan0/do-be-done-server"
          target="_blank"
          rel="noopener noreferrer"
        >
          Backend Code
        </a>
      </div>
    </div>
  );
};

export default ProjectOne;
